/**
 * The standings page's two views: the phase's table and the event's bracket.
 * The view is a URL search param (`?view=bracket`), so Back and a copied link
 * keep it; without one, the page opens on what the phase actually has.
 */
export const STANDINGS_TABS = ["standings", "bracket"] as const;
export type StandingsTab = (typeof STANDINGS_TABS)[number];

/**
 * Which view shows. No bracket → always the table. A phase with no table
 * (`phaseHasTable`: a knock-out round, or rule `NONE`) opens on the bracket;
 * every other phase opens on its table. An explicit `?view=` wins.
 */
export function activeTab(requested: StandingsTab | undefined, hasTable: boolean, bracket: boolean): StandingsTab {
	if (!bracket) return "standings";
	return requested ?? (hasTable ? "standings" : "bracket");
}
